<script setup lang="ts">
    import { Role } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import Delete from '@/components/Delete.vue';
    import EditRoles from './EditRoles.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        role: Role;
    }

    defineProps<Props>();

    const { hasPermission } = usePermissions();
</script>

<template>
    <DataTableActions :data="role">
        <EditRoles
            v-if="hasPermission(Permission.ROLES_UPDATE)"
            :role="role"
        />
        <Delete
            v-if="hasPermission(Permission.ROLES_DELETE)"
            :route="route('v2.roles.destroy', { id: role.id })"
            :query-key="[QueryKey.ROLES]"
            header="roles.delete.title"
            description="roles.delete.content"
        />
    </DataTableActions>
</template>
